import { render, staticRenderFns } from "./FamiliesWithIcon.vue?vue&type=template&id=71a7dc1e&scoped=true&"
import script from "./FamiliesWithIcon.vue?vue&type=script&lang=js&"
export * from "./FamiliesWithIcon.vue?vue&type=script&lang=js&"
import style0 from "./FamiliesWithIcon.vue?vue&type=style&index=0&id=71a7dc1e&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71a7dc1e",
  null
  
)

export default component.exports